import request from '@/utils/request'

export function findFinanceLedgerTransfers(params) {
  return request({
    url: '/finance_ledger/transfers',
    method: 'get',
    params
  })
}

export function exportFinanceLedgerTransfers(data) {
  return request({
    url: '/finance_ledger/transfers/export',
    method: 'post',
    data
  })
}

export function findFinanceLedgerOpenChannelOperationTypeOptions() {
  return request({
    url: '/finance_ledger/open_channel_payments/operation_type_options',
    method: 'get'
  })
}

export function findFinanceLedgerOpenChannelPayments(params) {
  return request({
    url: '/finance_ledger/open_channel_payments',
    method: 'get',
    params
  })
}

export function exportFinanceLedgerOpenChannelPayments(data) {
  return request({
    url: '/finance_ledger/open_channel_payments/export',
    method: 'post',
    data
  })
}

export function findFinanceLedgerOpenChannelPayWayOptions() {
  return [
    { name: '微信支付', slug: 'wechat_pay' },
    { name: '支付宝', slug: 'alipay' },
    { name: '聚合支付', slug: 'allinone_pay' }
  ]
}

export function findFinanceLedgerTransferTypeOptions() {
  return [
    { label: '线上收款', value: 'online_deposit' },
    { label: '线下收款', value: 'offline_deposit' },
    { label: '扣款', value: 'withdrawal' }
  ]
}
